import * as React from 'react'
import styled from 'styled-components'
import {raise} from '../theme'
import {observer} from 'mobx-react'
import {PillButton} from '../elements/Button'

export interface IModalProps {
  title: string | React.ReactNode
  isOpen: boolean
  onClose?: () => void
  onCloseText?: string
  className?: string
  children?: React.ReactNode
}

@observer
class ModalClass extends React.Component<IModalProps> {
  render() {
    return this.props.isOpen ? (
      <div className={this.props.className}>
        <ModalContent onClick={e => e.stopPropagation()}>
          <ModalHeader>
            <ModalTitle>{this.props.title}</ModalTitle>
          </ModalHeader>
          {this.props.children}
          <ActionButtons>
            {this.props.onClose && (
              <PillButton intent={'primary'} onClick={this.props.onClose}>
                {this.props.onCloseText}
              </PillButton>
            )}
          </ActionButtons>
        </ModalContent>
      </div>
    ) : null
  }
}

export const ModalTitle = styled.h3`
  font-weight: 300;
  color: black;
  margin: 0.8rem 0;
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

const ModalContent = styled.div`
  padding: 1rem 2rem;
  background: white;
  width: 400px;
  min-width: 600px;
  height: auto;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  ${raise(2)};

  @media screen and (max-height: 900px) {
    top: 50%;
    transform: translate(-50%, -70%);
  }

  @media screen and (max-width: 600px) {
    width: 90%;
    min-width: auto;
  }
`

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 1.3rem;
  ${PillButton} {
    margin: auto;
    padding: 10px 40px;
  }
`

export const Modal = styled(ModalClass)`
  position: fixed;
  overflow-y: scroll;
  padding-bottom: 2rem;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.65);
`
